import { Table, Typography, Badge } from "antd"
import React, { useEffect, useState } from "react"
import { OrderAndPrefix } from "../../Orders/Helpers/OrderAndPrefix"
import { generateFilter } from "../../Orders/JobFilters"
import { returnProperMachineTag } from "../../utils/ReturnProperMachineTag"
import { OrderLocation } from "../../Orders/OrderLocation"
import moment from "moment/moment"
import { db } from "../../../firebase/config"
import { collection, onSnapshot, query, where } from "firebase/firestore"

const { Text } = Typography

export default function DoneCutterOrders({ activeKey }) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    if (activeKey === 2) {
      setLoading(true)
      //ref for notifications
      const ordersRef = collection(db, "orders")

      // query
      const activeQ = query(
        ordersRef,
        where("orderStatus", "==", 6),
        where("selectedProduct.machine", "==", "Cutter")
      )

      //gets data with query
      const unsubscribe = onSnapshot(activeQ, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })

        //sets notification data
        setData(results)

        //removes loading
        setLoading(false)
      })
      //executes function
      return () => unsubscribe()
    }
  }, [activeKey])
  //filters
  let clientFilters = generateFilter(data, ["client", "client"])
  let productFilter = generateFilter(data, ["selectedProduct", "product", "productName"])
  let materialFilter = generateFilter(data, ["selectedProduct", "material"])
  let machineFilter = generateFilter(data, ["selectedProduct", "machine"])

  //default columns for table
  const defaultColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      sorter: (a, b) => a.orderNumber - b.orderNumber,
      render: (value, record) => OrderAndPrefix(record),
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
      filters: clientFilters,
      onFilter: (value, record) => record.client.client.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
      filters: productFilter,
      onFilter: (value, record) => record.selectedProduct.product.productName.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Manager",
      dataIndex: "user",
      align: "center",
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
      align: "center",
    },
    {
      title: "Machine",
      dataIndex: ["selectedProduct", "machine"],
      align: "center",
      filters: machineFilter,
      onFilter: (value, record) => record.selectedProduct.machine.startsWith(value),
      filterSearch: true,
      render: (value) => {
        return returnProperMachineTag(value)
      },
    },

    {
      title: "Material",
      dataIndex: ["selectedProduct", "material"],
      align: "center",
      filters: materialFilter,
      onFilter: (value, record) => record.selectedProduct.material.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Location",
      dataIndex: "orderStatus",
      align: "center",
      render: (value) => <Badge status="processing" text={OrderLocation(value)} />,
    },

    {
      title: "Core",
      align: "center",
      dataIndex: "coreSize",
    },
    {
      title: "Boxes",
      align: "center",
      dataIndex: "boxesCount",
    },
    {
      title: "Amount Created",
      align: "center",
      dataIndex: "amountCreated",
    },
    {
      title: "Done time",
      dataIndex: "doneByCutter",
      align: "center",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.doneByCutter.seconds - b.doneByCutter.seconds,
      render: (value) => (
        <>
          <Text>{value && moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
  ]

  return (
    <div>
      <Table
        style={{ marginTop: "15px" }}
        size="small"
        loading={loading}
        columns={defaultColumns}
        dataSource={data}
        rowKey={(record) => record.id}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
      />
    </div>
  )
}
